/** Portal org product entitlements (enabled_services on enterprise_salon_organizations). */

import { persistSalonHubOrgServices } from '../../beauty-shared/config/salonHubEntitlements';

export const ORG_SERVICE_KEYS = [
  "skin_analysis",
  "hair_analysis",
  "hair_style",
  "makeup",
  "hair_coloring",
  "reels",
  "customer_engagement",
  "whatsapp",
];

const LEGACY_SERVICE_ALIASES = {
  video_editor: "reels",
};

export function normalizeOrgServiceKey(key) {
  const k = String(key || "").trim().toLowerCase();
  return LEGACY_SERVICE_ALIASES[k] || k;
}

export function normalizeOrgEnabledServices(raw) {
  if (!Array.isArray(raw)) return [];
  const out = [];
  const seen = new Set();
  for (const item of raw) {
    const key = normalizeOrgServiceKey(item);
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(key);
  }
  if (seen.has("customer_engagement") && !seen.has("whatsapp")) out.push("whatsapp");
  return out;
}

export const ORG_ENTITLEMENTS_UPDATED_EVENT = "enterprise-org-entitlements-updated";

export function effectiveOrgEnabledServices(raw) {
  return normalizeOrgEnabledServices(raw);
}

export function orgStorageKey(portal) {
  if (portal === "workspace") return "enterprise_workspace_enabled_services";
  if (portal === "executive") return "enterprise_executive_enabled_services";
  return "enterprise_partner_enabled_services";
}

export function readStoredOrgEnabledServices(portal) {
  try {
    const raw = localStorage.getItem(orgStorageKey(portal));
    if (!raw) return [];
    return normalizeOrgEnabledServices(JSON.parse(raw));
  } catch {
    return [];
  }
}

export function storeOrgEnabledServices(portal, services) {
  const list = normalizeOrgEnabledServices(services);
  localStorage.setItem(orgStorageKey(portal), JSON.stringify(list));
}

export function orgHasService(services, key) {
  return effectiveOrgEnabledServices(services).includes(normalizeOrgServiceKey(key));
}

export function persistOrgEnabledServicesFromLogin(portal, data) {
  const raw = data?.enabledServices ?? data?.enabled_services;
  if (Array.isArray(raw)) {
    storeOrgEnabledServices(portal, raw);
    persistSalonHubOrgServices(raw);
    return true;
  }
  return false;
}
